import React from 'react';
import ListContent from './listContent';

// La liste porte ses propres fiches : cet enrobage n'ajoutait qu'une grille.
function Contents() {
  return <ListContent />;
}

export default Contents;
